import { LayoutDashboard, Store, Boxes, Download, User, Package, FolderTree, Users, UserCheck, Image, FileText, Settings, ShieldCheck, MailOpen } from "lucide-react";

export const MEMBER_MENU = [
  { to: "/member/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/products", label: "Katalog", icon: Store },
  { to: "/member/products", label: "Produk Saya", icon: Boxes },
  { to: "/member/downloads", label: "Riwayat Download", icon: Download },
  { to: "/member/profile", label: "Profil", icon: User },
];

export const ADMIN_MENU = [
  { to: "/admin/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/admin/products", label: "Produk", icon: Package },
  { to: "/admin/categories", label: "Kategori", icon: FolderTree },
  { to: "/admin/members", label: "Member", icon: Users },
  { to: "/admin/member-approvals", label: "Persetujuan Member", icon: UserCheck },
  { to: "/admin/admins", label: "Kelola Admin", icon: ShieldCheck },
  { to: "/admin/downloads", label: "Download", icon: Download },
  { to: "/admin/messages", label: "Pesan Masuk", icon: MailOpen },
  { to: "/admin/banners", label: "Banner", icon: Image },
  { to: "/admin/pages", label: "Halaman", icon: FileText },
  { to: "/admin/settings", label: "Pengaturan", icon: Settings },
  { to: "/admin/profile", label: "Profil Admin", icon: User },
];
